<script>
  import { getContext } from "svelte";
  import SortableList from "../SharedComponents/Sortable.svelte";
  import { countryStore } from "../store/Countries.js";
  import * as util from "../js/util.js";
  import Plus from "../Vectors/Plus.svelte";
  import Icon from "../SharedComponents/Icon.svelte";
  import VarListEditor from "../SharedComponents/VarListEditor.svelte";
  import CustomSelectBox from "../SharedComponents/CustomSelectBox.svelte";
  import { link, navigate } from "svelte-routing";
  import { Tabs, Tab, TabList, TabPanel } from "svelte-tabs";
  import Table from "../SharedComponents/Table.svelte";
  import EditCountryVersionVar from "./EditCountryVersionVar.svelte";
  import EditCountryVersionSectionSub from "./EditCountryVersionSectionSub.svelte";

  const { snackbar } = getContext("app");

  export let id;
  let sectionSubId;
  let currentCountryVersion;
  let fileInputControl;
  let files;
  let messages = [];
  let messagesClass;
  let uploadBusy;
  $: bs = countryStore.getCountryVersion(id);
  $: currentCountryVersion = $countryStore.currentCountryVersion;
  const { open } = getContext("modal");

  async function UploadFile() {
    uploadBusy = true;
    messages = [];
    let thefile = files[0];
    var result = await countryStore.importExcel(thefile, id);

    messagesClass = "success";
    if (result.success == false) {
      messagesClass = "error";
    }
    messages = ["using file " + thefile.name, result.message];
    files = null;
    fileInputControl.value = "";
    uploadBusy = false;
    if (result.success) {
      countryStore.getCountryVersion(id);
    }
  }
  function stopIfPublished() {
    if (currentCountryVersion.isPublished) {
      snackbar("error", "published versions cannot be editted");
      return true;
    }
  }

  async function downloadExcel() {
    let filename = `${currentCountryVersion.country.nameKey}-${currentCountryVersion.mainVersion}.${currentCountryVersion.subVersion}.xlsx`;
    util.downloadFile("api/country/getcountryversionexcel/" + id, filename);
  }
  async function addSection() {
    if (stopIfPublished()) return;
    var result = await countryStore.saveSectionSub({
      countryVersionId: parseInt(id),
    });
    if (!result.success) {
      snackbar("error", result.message);
      return;
    }
    await countryStore.getCountryVersion(id);
  }
  function toggleDetail(id) {
    if (sectionSubId == id) {
      sectionSubId = null;
    } else {
      sectionSubId = id;
    }
  }

  async function copyversion() {
    snackbar("info", "starting copy....");
    var result = await countryStore.copyCountryVersion({
      id: currentCountryVersion.id,
    });
    navigate("/app/countryversion/" + result.data);
    snackbar("info", "version copied");
  }

  async function downloadversion() {
    util.downloadFile(
      "api/country/downloadcountryversion/" + id,
      `${currentCountryVersion.country.nameKey}-${currentCountryVersion.mainVersion}.${currentCountryVersion.subVersion}.json`
    );
    // var result = await countryStore.downloadCountryVersion({
    //   id: currentCountryVersion.id,
    // });
    // navigate("/app/countryversion/" + result.data);
  }
  async function innerSave() {
    return result;
  }
  async function save() {
    if (stopIfPublished()) return;

    var result = await countryStore.saveCountryVersion(currentCountryVersion);
    if (!result.success) {
      snackbar("error", result.message);
    }
    result.success && countryStore.getCountryVersion(id);
  }
  async function publish() {
    if (stopIfPublished()) return;

    currentCountryVersion.isPublished = true;
    var result = await countryStore.saveCountryVersion(currentCountryVersion);
    if (!result.success) {
      snackbar("error", result.message);
    } else {
      snackbar(
        "info",
        "published this version, no changes are possible anymore"
      );
      countryStore.getCountryVersion(id);
    }
  }
  function AddSection() {
    if (stopIfPublished()) return;

    open(EditSefinition, {
      countryVersionId: currentCountryVersion.id,
    });
  }

  function editVersionVariable(thevar) {
    var foundVar = currentCountryVersion.variables.find(
      (cvv) => cvv.id == thevar.id
    );
    foundVar.countryVersionId = parseInt(id);
    open(EditCountryVersionVar, { countryVersionVar: foundVar });
  }

  function addVersionVariable() {
    if (stopIfPublished()) return;
    open(EditCountryVersionVar, {
      countryVersionVar: { countryVersionId: parseInt(id) },
    });
  }

  function sortList(ev) {
    if (Date.now() - window.lastVarSortTime < 100) return; // weird bug that the both sorters are being triggered
    currentCountryVersion.sections = ev.detail;
    save();
  }
  $: useVariables =
    currentCountryVersion.variables &&
    currentCountryVersion.variables
      .sort((a, b) => {
        return a.varNameKey == b.varNameKey
          ? 0
          : a.varNameKey > b.varNameKey
          ? 1
          : -1;
      })
      .map((u) => {
        return {
          id: u.id,
          columns: {
            name: u.varNameKey,
            dataType: u.dataType,
            readOnly: u.readOnly ? "yes" : "no",
            scenarioTool: u.includeInScenarioManager,
            formula: u.formula,
          },
        };
      });

  async function deleteSection(sectionId) {
    if (stopIfPublished()) return;

    var result = await countryStore.deleteSection(sectionId);
    if (!result.success) {
      snackbar("error", result.message);
    } else {
      snackbar("info", "deleted this section");
      countryStore.getCountryVersion(id);
    }
  }
</script>

{#if currentCountryVersion.country}
  <h2 class="col-12 text-primary">
    <a use:link href="/app/countries/{currentCountryVersion.countryId}"
      >{currentCountryVersion.country.nameKey}</a
    >
    {currentCountryVersion.mainVersion}.{currentCountryVersion.subVersion}
  </h2>
  <Tabs>
    <TabList>
      <Tab>General</Tab>
      <Tab>All variables</Tab>
      <Tab>Sections</Tab>
    </TabList>
    <TabPanel>
      <div class="col-8 pr-1">
        <label for="mainversion">Main version #</label>
        <input
          readonly={currentCountryVersion.isPublished}
          type="number"
          class="form-control"
          id="mainversion"
          on:blur={save}
          placeholder="main version"
          bind:value={currentCountryVersion.mainVersion}
          required=""
        />
        <label for="subversion">Sub version #</label>
        <input
          readonly={currentCountryVersion.isPublished}
          type="number"
          class="form-control"
          id="subversion"
          on:blur={save}
          placeholder="sub version"
          bind:value={currentCountryVersion.subVersion}
          required=""
        />
      </div>
      <div class="col-4 pr-1">
        <button
          disabled={currentCountryVersion.isPublished}
          class="btn btn-primary"
          on:click={publish}>Publish</button
        >
        <button class="btn btn-primary" on:click={copyversion}
          >Make a copy</button
        >
        <button
          class="btn btn-secondary"
          on:click={downloadversion}
          title=" (eg to move it to production, or back it up
        somewhere)">Download / Export</button
        >
      </div>
    </TabPanel>
    <TabPanel>
      Upload Excel... this overwrites existing var formulas, and add new ones,
      but does NOT delete redunant variables
      <div class="mb-3" style="width: 400px; height: 30px; overflow: hidden;">
        <div
          style="width: 360px; height: 40px; position: relative; top: 10px; left:
          0px;text-decoration:underline;cursor:pointer"
        >
          {#if files}{files[0].name}{:else}Choose file{/if}
        </div>
        <input
          type="file"
          id="upload_input"
          bind:files
          bind:this={fileInputControl}
          name="upload"
          style="font-size: 50px; width: 120px; opacity: 0;
          filter:alpha(opacity=0); position: relative; top: -40px;; left: -20px"
          title=""
        />
      </div>
      {#if !uploadBusy}
        {#if files}
          <button
            visible={!uploadBusy}
            on:click={UploadFile}
            class="btn btn-primary mb-3">Upload</button
          >
        {/if}
      {:else}bezig met uploaden...{/if}
      <ul class={messagesClass}>
        {#each messages as message}
          <li>{message}</li>
        {/each}
      </ul>

      <button class="btn btn-primary" on:click={downloadExcel}>
        download excel
      </button>
      <Table
        Title=""
        bind:Items={useVariables}
        AddRowCallBack={addVersionVariable}
        RowClickCallBack={editVersionVariable}
      />
    </TabPanel>
    <TabPanel>
      <h2 class="w-100 mb-3">
        <div style="float:right">
          <Plus on:click={addSection} />
        </div>
      </h2>
      <div class="table-responsive">
        You can drag items to change the sorting... although the sorting is
        global here... of course in the app the factory items are shown
        together, and those marked as summary are shown separately.
        <ul>
          <li>
            <div>
              <table
                class="table table-striped-xx table-sm list fold-out lessmargin"
              >
                <thead>
                  <tr>
                    <th width="70%">Naam</th>
                    <th width="15%">Section type</th>
                    {#if !stopIfPublished()}
                      <th width="15%">delete</th>
                    {/if}
                  </tr>
                </thead>
              </table>
            </div>
          </li>
        </ul>
        {#if currentCountryVersion.sectionSubs}
          <SortableList
            list={currentCountryVersion.sectionSubs}
            key="id"
            on:sort={sortList}
            let:item
          >
            <div>
              <table
                class="table table-striped-xx table-sm list fold-out lessmargin"
              >
                <tbody>
                  <tr id="testtr" on:click={toggleDetail(item.id)}>
                    <td width="70%">{item.nameKey}</td>
                    <td width="15%">{item.sectionType}</td>
                    {#if !stopIfPublished()}
                      <td width="15%"
                        ><button
                          class="btn btn-secondary"
                          on:click|preventDefault={(e) => {
                            deleteSection(item.id, e);
                            e.preventDefault();
                            e.cancelBubble = true;
                            return true;
                          }}>Delete</button
                        ></td
                      >
                    {/if}
                  </tr>
                  {#if sectionSubId == item.id}
                    <tr class="detail">
                      <td colspan="3">
                        <EditCountryVersionSectionSub
                          sectionSub={item}
                          allSections={currentCountryVersion.sectionSubs}
                        />
                      </td>
                    </tr>
                  {/if}
                </tbody>
              </table>
            </div>
          </SortableList>
        {/if}
      </div>
    </TabPanel>
  </Tabs>
{/if}

<style>
  ul {
    list-style: none;
    padding: 0;
    margin: 0px;
    padding: 0px;
  }
  li {
    border: 2px dotted transparent;
    transition: border 0.1s linear;
    margin: 0px;
    padding: 0px;
  }
  table.lessmargin {
    margin-bottom: 0px !important;
    border-bottom: 0px !important;
  }
  .lessmargin th {
    border-bottom: 0px;
  }
</style>
